/* eslint-disable */ 
import { URL } from '../../../config'
import { getRequest } from '../../../utils/functions/httpRequest'

export const getSeasonsRankingByPlayer = function (playerId) 
{
    const endpoint = `/${playerId}/rankingSeasonsByPlayer`
    const rankingURL = `${URL.ranking}${endpoint}` 
    return getRequest(rankingURL)
} 
 



// WEBPACK FOOTER //
// ./src/components/pages/api/getSeasonsRankingByPlayer.js